import { render, staticRenderFns } from "./PredictSettings.vue?vue&type=template&id=264c408c&scoped=true&"
import script from "./PredictSettings.vue?vue&type=script&lang=js&"
export * from "./PredictSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c408c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VForm,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/var/apps/oil/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('264c408c')) {
      api.createRecord('264c408c', component.options)
    } else {
      api.reload('264c408c', component.options)
    }
    module.hot.accept("./PredictSettings.vue?vue&type=template&id=264c408c&scoped=true&", function () {
      api.rerender('264c408c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Problem/PredictSettings.vue"
export default component.exports